var map = {
	"../pages/auto-clocking/auto-clocking.module": [
		863,
		4
	],
	"../pages/login/login.module": [
		859,
		3
	],
	"../pages/manually-clocking/manually-clocking.module": [
		862,
		2
	],
	"../pages/page1/page1.module": [
		860,
		0
	],
	"../pages/settings/settings.module": [
		861,
		1
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 236;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src lazy
// module id = 236
// module chunks = 5